import React, { Component } from 'react';
import counterpart from 'counterpart';

import SelectInput from 'Components/forms/select-input/SelectInput.jsx';

import './PassFiles.scss';
import deleteIcon from '../../../app/src/assets/img/deleteIcon.svg';

export class PassFiles extends Component {

  constructor(props) {
    super(props);
    this.state = {
    };

    this.attachBindings();
  }

  attachBindings() {
    this.deleteFile = this.deleteFile.bind(this);
  }

  deleteFile = () => {
    this.props.deleteFile(this.props.keys);
  }

  render() {
    return (
      <>
      <table>
      { this.props.files.status === "PENDING" &&
        <td className="valid-file-type">
          {this.props.files.file.name.length > 30 ? this.props.files.file.name.substring(0, 30).concat('...') : this.props.files.file.name}
          <div className="myBars" id={this.props.files.file.name} style={{ width: this.props.width }}></div>
        </td>
      }
      { this.props.files.status === "SUCCESS" &&
        <td className="uploaded-file-names">
        {this.props.files.file.name.length > 30 ? this.props.files.file.name.substring(0, 30).concat('...') : this.props.files.file.name}
        </td>
      }
      <td>
       <SelectInput
          dataList={this.props.dataList}
          promptText="Select"
          handleSelection={(event) => this.props.onSelectChange(event,this.props.keys)}
          selectedItem={this.props.selectedDocType}
          wrapperClass="select-menu__form"
          extraClass="upload_docs"
        />
      </td>
      <td>
            <img src={deleteIcon} alt="icon" className="delete-icon" onClick={this.deleteFile} />
      </td>
      </table>
      <div className="seperator-line-file"></div>
      </>
    );
    }
  }

export default PassFiles;